<template>
  <div class="search-result__section">
    <h2 class="search-result__section-title">
      <a-link v-if="to" :to="to" class="subtitle-1">{{ title }}</a-link>
      <template v-else>{{ title }}</template>
    </h2>

    <span
      v-if="description"
      class="search-result__description subtitle-2 normal"
    >
      {{ description }}
    </span>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'

export default {
  name: 'ASearchResultSectionHeader',
  props: {
    title: propValidator([PROP_TYPES.STRING], false),
    description: propValidator([PROP_TYPES.STRING], false),
    to: propValidator([PROP_TYPES.STRING, PROP_TYPES.OBJECT], false)
  }
}
</script>

<style lang="scss" scoped>
.search-result__section {
  border-bottom: 2px solid $c--black;
  padding-bottom: 4px;

  .search-result__section-title {
    display: inline-block;
    margin-right: 20px;

    @include mobile {
      display: block;
      margin-right: 0;
    }
  }

  .search-result__description {
    display: inline-block;

    @include mobile {
      margin-top: 10px;
    }
  }
}
</style>
